import React from "react";
import { Star, AlertCircle, Crown, MessageSquare, Flame, Crosshair, Users, FolderKanban } from "lucide-react";

const SECTION_CONFIG = {
  vantagens: { title: "Vantagens", Icon: Star, accent: "#00664C" },
  desvantagens: { title: "Pontos de Atenção", Icon: AlertCircle, accent: "#8A6D1B" },
  estiloLideranca: { title: "Estilo de Liderança", Icon: Crown, accent: "#00664C" },
  estiloComunicacao: { title: "Estilo de Comunicação", Icon: MessageSquare, accent: "#00664C" },
  reacaoSobPressao: { title: "Reação sob Pressão", Icon: Flame, accent: "#00664C" },
  tomadaDeDecisoes: { title: "Tomada de Decisões", Icon: Crosshair, accent: "#00664C" },
  relacionamentos: { title: "Relacionamentos", Icon: Users, accent: "#00664C" },
  organizacaoPlanejamento: { title: "Organização e Planejamento", Icon: FolderKanban, accent: "#00664C" },
};

export default function NarrativeSection({ sectionKey, content }) {
  const config = SECTION_CONFIG[sectionKey] || { title: sectionKey, Icon: Star, accent: "#00664C" };
  const { title, Icon, accent } = config;

  return (
    <div
      className="rounded-2xl bg-white"
      style={{ border: "1px solid #E5E9EA", boxShadow: "0 1px 2px 0 rgba(0,0,0,0.04)" }}
    >
      <div className="flex items-center gap-3 px-6 pt-5 pb-3">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ background: accent === "#8A6D1B" ? "#FEF3CD" : "#EAFAF6" }}
        >
          <Icon className="w-4 h-4" style={{ color: accent }} />
        </div>
        <h4
          className="text-sm font-semibold"
          style={{ fontFamily: "Poppins, sans-serif", color: "#2E3233" }}
        >
          {title}
        </h4>
      </div>
      <p
        className="text-sm leading-[1.7] px-6 pb-5"
        style={{ fontFamily: "Work Sans, sans-serif", color: "#646C6F" }}
      >
        {content}
      </p>
    </div>
  );
}
